import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const ProductBlockOuter = /*#__PURE__*/ React.forwardRef(({ className , tealiumAttributes , children  }, ref)=>{
    return /*#__PURE__*/ React.createElement("article", swcHelpers.extends({
        ref: ref,
        className: classnames('v2-product-block-outer', className)
    }, tealiumAttributes), children);
});

export { ProductBlockOuter };
//# sourceMappingURL=ProductBlockOuter.js.map
